import { useState, useEffect } from 'react';
import Env from 'Env';

/**
 * Manages the two-phase state transition for the EV reissue acknowledge modal.
 *
 * The two-phase approach (triggerEvAcknowledge → showEvAcknowledgeModal via useEffect)
 * ensures the reissue confirm modal has fully unmounted before the acknowledge modal
 * opens, preventing the design system from silently dropping the second open() call
 * when two modals are opened in the same render cycle.
 *
 * When onEvReissueComplete is provided, the parent owns the acknowledge modal —
 * we call the callback directly instead of setting showEvAcknowledgeModal=true,
 * so the local AcknowledgeModal never needs to render.
 */
export function useEvAcknowledgeModal(onEvReissueComplete?: () => void) {
  const [evReissueConfirmed, setEvReissueConfirmed] = useState(false);
  const [showEvAcknowledgeModal, setShowEvAcknowledgeModal] = useState(false);
  const isEvWay4Enabled = typeof Env.getIsEvWay4Enabled === 'function' ? Env.getIsEvWay4Enabled() : false;

  useEffect(() => {
    if (evReissueConfirmed) {
      setEvReissueConfirmed(false);
      if (!isEvWay4Enabled) {
        return;
      }
      if (onEvReissueComplete) {
        onEvReissueComplete();
      } else {
        setShowEvAcknowledgeModal(true);
      }
    }
  }, [evReissueConfirmed, isEvWay4Enabled, onEvReissueComplete]);

  return {
    showEvAcknowledgeModal,
    setShowEvAcknowledgeModal,
    triggerEvAcknowledge: () => setEvReissueConfirmed(true),
  };
}
